import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { MILESTONES, TROPHY_SRC, crestSrc } from "../lib/rewards";

// Menu → Rewards: every crest (earned ones lit, the rest waiting) and every champion trophy the player has won.
export const RewardsSection = () => {
  const [r, setR] = useState(null);
  useEffect(() => { api.get("/api/leaderboard/me/rewards").then((x) => setR(x.data)).catch(() => {}); }, []);
  if (!r) return null;
  return (
    <section data-testid="rewards-section">
      <h3 className="text-[10px] uppercase tracking-[0.3em] text-slate-400 mb-3">Rewards · level {r.level}</h3>
      <div className="grid grid-cols-5 gap-2" data-testid="rewards-crests">
        {MILESTONES.map((m) => {
          const earned = r.level >= m;
          return (
            <div key={m} data-testid={`reward-crest-${m}`} data-earned={earned ? "true" : "false"} title={earned ? `Level ${m} reached` : `Reach level ${m}`}
              className="flex flex-col items-center gap-1">
              <img src={crestSrc(m)} alt={`Level ${m} crest`} className={`w-14 h-14 object-contain transition-transform hover:scale-110 ${earned ? "drop-shadow-[0_0_10px_rgba(251,191,36,0.45)]" : "grayscale opacity-30"}`} />
              <span className={`text-[10px] ${earned ? "text-amber-200" : "text-slate-500"}`}>LV {m}</span>
            </div>
          );
        })}
      </div>
      <div className="mt-4 flex flex-col gap-2" data-testid="rewards-badges">
        {r.badges.length === 0
          ? <p className="text-[11px] text-slate-500">Win the Monthly Bankroll Builder to earn a champion trophy.</p>
          : r.badges.map((b) => (
            <div key={b.key} data-testid={`reward-badge-${b.key}`} className="flex items-center gap-3 rounded-xl border border-amber-400/30 bg-amber-400/5 px-3 py-2">
              <img src={TROPHY_SRC} alt="" className="w-8 h-8 object-contain" />
              <span className="text-sm text-amber-100">{b.label}</span>
            </div>
          ))}
      </div>
    </section>
  );
};
